<template>
    <div>
        <div v-html="computedContents" v-if="dataSource.isHtml"></div>
        <div v-else>{{computedContents}}</div>
    </div>
</template>
<script>
export default {
    name: 'yl-lc-text',
    props:{
        dataSource: {
            type: Object,
            required:true,
            defalut: {}
        },
        scope: {
            type: Object,
            defalut: {}
        }
    },
    data(){
        return {
            htmlContent: null,
        }
    },
    watch:{
        "dataSource":{
            handler(data){
                if(data.isHtml){
                    this.htmlContent = window.LOWCODE.source ? this.$lowcode.createMatchTextHtml(data.body,this.scope) : this.$store.getters.getTextHtml(data.body)
                }else{
                    this.htmlContent = window.LOWCODE.source ? this.$lowcode.createMatchField(data.body,this.scope) : this.$store.getters.getSourceVal(data.body);
                }
            },
            immediate: true
        }
    },
    computed: {
        computedContents() {
            let computedContent = null
            if(this.dataSource.isHtml){
                computedContent = window.LOWCODE.source ? this.$lowcode.createMatchTextHtml(this.dataSource.body,this.scope) : this.$store.getters.getTextHtml(this.dataSource.body)
            }else{
                computedContent = window.LOWCODE.source ? this.$lowcode.createMatchField(this.dataSource.body,this.scope) : this.$store.getters.getSourceVal(this.dataSource.body);
            }
            return computedContent;
        }
    },
    methods: {
    },
}
</script>